import vitegoAppIconDark from '../assets/vitego-app-icon-dark.svg';
import vitegoAppIconLight from '../assets/vitego-app-icon-light.svg';

const VITEGO_APP_ICON_SIZE = 128;

export function VitegoAppIcon() {
  return (
    <span aria-hidden="true" className="vitego-app-icon">
      <img alt="" className="vitego-app-icon__light" height={VITEGO_APP_ICON_SIZE} src={vitegoAppIconLight} width={VITEGO_APP_ICON_SIZE} />
      <img alt="" className="vitego-app-icon__dark" height={VITEGO_APP_ICON_SIZE} src={vitegoAppIconDark} width={VITEGO_APP_ICON_SIZE} />
    </span>
  );
}
